import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WaiterClass;
function Waiter() {
  if (WaiterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Waiter');
    WaiterClass = $;
  }
  return WaiterClass;
}
//region block: exports
export {
  Waiter as Waiter3lxa2a79zyo0g,
};
//endregion

//# sourceMappingURL=Waiter.mjs.map
